<template>
  <div class="bill container h-100">
    <bill-export ref="export" :search="searchCondition"/>
    <div class="content">
      <div class="header">
        <el-form
            :model="searchCondition"
            inline
            class="form"
            label-width=""
            size="mini"
        >
          <el-form-item label="" label-width="100px">
            <el-date-picker
                style="width: 300px"
                v-model="searchCondition.check_time"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="审核时间开始日期"
                end-placeholder="审核时间结束日期"
                clearable
                @change="onSubmit"
                @clear="onSubmit"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <CompanySelect
                :company-id.sync="searchCondition.company_id"
                style="width: 120px"
            />
          </el-form-item>
          <el-form-item label="">
            <el-input
                v-model="searchCondition.customer_name"
                placeholder="请输入客户名称"
                @change="onSubmit"
                clearable
            />
          </el-form-item>
          <el-form-item label="">
            <el-input
                v-model="searchCondition.invoice_title"
                placeholder="请输入发票抬头"
                @change="onSubmit"
                clearable
            />
          </el-form-item>
          <el-form-item label="">
            <el-input
                v-model="searchCondition.invoice_number"
                placeholder="请输入发票号码"
                @change="onSubmit"
                clearable
            />
          </el-form-item>
          <el-form-item label="">
            <el-input
                v-model="searchCondition.tax_id"
                placeholder="请输入税号"
                @change="onSubmit"
                clearable
            />
          </el-form-item>
          <el-form-item label="">
            <el-select
                v-model="searchCondition.applicant_id"
                placeholder="请选择申请人"
                style="width: 140px"
                clearable
                filterable
                @change="onSubmit"
            >
              <el-option
                  v-for="(status, key) in userOption"
                  :key="key"
                  :label="userOption[key]"
                  :value="key"
              ></el-option>
            </el-select>

            <el-select
                v-model="searchCondition.is_done_invoice"
                placeholder="是否开完"
                style="width: 140px;margin-left: 10px;"
                clearable
                @change="onSubmit"
            >
              <el-option label="是" value="Y"/>
              <el-option label="否" value="N"/>
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button
                type="primary"
                class="el-button--operation"
                size="mini"
                style="margin-left: 20px"
                @click="onSubmit"
            >查询
            </el-button>
            <el-button @click="onReset" style="margin-right: 0" size="mini"
            >重置
            </el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="tableCon">
        <div class="tab-content">
          <div style="height: 40px; text-align: left; margin-bottom: 10px">
            <div
                :class="
                'tab-table' + (tabActive === 0 ? ' tab-table-active' : '')
              "
                @click="tabClick(0)"
            >
              待审核
            </div>
            <div
                :class="
                'tab-table' + (tabActive === 1 ? ' tab-table-active' : '')
              "
                @click="tabClick(1)"
            >
              已通过
            </div>
            <div
                :class="
                'tab-table' + (tabActive === 2 ? ' tab-table-active' : '')
              "
                @click="tabClick(2)"
            >
              已拒绝
            </div>
            <div
                :class="'tab-table'"
                v-permission="'can_invoice_export'"
                style="
                float: right;
                margin-right: 10px;
                margin-top: 10px;
                background-color: #ffffff;
                border: 1px solid #ffffff;
              "
            >
              <el-dropdown class="export-dropdown" @command="handleExport">
                <div class="funcbars-button d-flex-row align-items-center">
                  审核导出
                  <i class="el-icon-arrow-down el-icon"/>
                </div>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="current">
                    导出当前
                  </el-dropdown-item>
                  <el-dropdown-item command="all">
                    导出全部
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div style="padding: 10px">
            <el-table
                class="data-table"
                :data="billData"
                v-loading="loading"
                element-loading-text="加载中……"
                element-loading-spinner="el-icon-loading"
                border
                :row-class-name="rowClassName"
                :expand-row-keys="expandKeys"
                :row-key="`id`"
                style="width: 100%"
            >
              <el-table-column type="expand">
                <template slot-scope="props">
                  <ApplyOrderTable :id="props.row.id" v-if="props.row.orders && isArray(props.row.orders)"/>
                </template>
              </el-table-column>
              <!--              <el-table-column-->
              <!--                  prop="source"-->
              <!--                  label="来源"-->
              <!--                  width="100"-->
              <!--                  align="center"-->
              <!--                  show-overflow-tooltip-->
              <!--              />-->
              <el-table-column
                  prop="index"
                  label="序号"
                  width="80"
                  align="center"
              />
              <el-table-column
                  prop="company_name"
                  label="乙方名称"
                  width="80"
                  align="center"
                  show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  <span>{{ row.company ? row.company.name : "--" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="applicant"
                  label="申请人"
                  width="100"
                  align="center"
                  show-overflow-tooltip
              />
              <el-table-column
                  prop="customer_name"
                  label="客户名称"
                  width="220"
                  :show-overflow-tooltip="true"
                  align="center"
              />
              <el-table-column
                  prop="invoice_title"
                  label="发票抬头"
                  width="260"
                  :show-overflow-tooltip="true"
                  align="left"
                  header-align="center"
              >
                <template slot-scope="{ row }">
                  <span>{{ row.invoice_title || '' }}</span>
                  <span class="invoice-source" v-if="row.source !== 'ad'">{{ row.source === 'ad' ? '广告' : '佣金' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="tax_id"
                  label="税号"
                  width="220"
                  :show-overflow-tooltip="true"
                  align="center"
              />
              <el-table-column
                  prop="invoice_number"
                  label="发票号码"
                  header-align="center"
                  align="center"
                  show-overflow-tooltip
              >
                <template slot-scope="{ row }">
                  <span>{{ row.invoice_number || "--" }}</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="amount_money"
                  label="发票金额"
                  header-align="center"
                  align="right"
              />
              <el-table-column
                  prop="check_money"
                  label="审核金额"
                  header-align="center"
                  align="right"
              />
              <el-table-column prop="status" label="审核状态" align="center">
                <template slot-scope="scope">
                  <span :style="{ color: statusFilterColor(scope.row.status) }">
                    <span
                        class="dot"
                        :style="{
                        background: statusFilterColor(scope.row.status),
                      }"
                    ></span>
                    {{ statusFilterText(scope.row.status) }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column v-if="tabActive === 1" label="是否开完" align="center">
                <template v-slot="{row:{is_done_invoice,id},$index}">
                  <div @mouseover="handleHoverDone($index,is_done_invoice)">
                    <span v-if="doneMap[is_done_invoice]"
                          :style="`color:${doneMap[is_done_invoice].color};cursor: pointer;`"
                    >
                      {{ doneMap[is_done_invoice].text }}
                    </span>
                    <el-popconfirm v-permission="'can_invoice_done'" v-if="hoverActive===$index" title="确认开票完成吗？"
                                   @confirm="handelMarkDone(id)">
                      <i slot="reference" class="iconfont icon-wancheng1" style="color: #ff3176;cursor: pointer;"/>
                    </el-popconfirm>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="created_at"
                  label="申请时间"
                  align="center"
                  width="115"
              >
                <template slot-scope="scope">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.created_at"
                      placement="top"
                  >
                    <span>
                      {{ scope.row.created_at |parseTime('{y}-{m}-{d}') }}
                    </span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                  prop="check_time"
                  label="审核时间"
                  align="center"
                  width="115"
              >
                <template slot-scope="scope">
                  <el-tooltip
                      class="item"
                      effect="dark"
                      :content="scope.row.check_time"
                      placement="top"
                  >
                    <span>
                      {{ scope.row.check_time |parseTime('{y}-{m}-{d}') }}
                    </span>
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column
                  label="审核人"
                  prop="checker_name"
                  align="center"
              >
                <template slot-scope="{ row }">
                  <span>{{ row.checker_name || "--" }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作项" width="160" align="center">
                <template slot-scope="scope">
                  <div class="buttons d-flex-row align-items-center">
                    <el-link
                        type="primary"
                        style="margin-right: 10px"
                        v-if="scope.row.orders && scope.row.orders.length > 0"
                        @click="appendExpandKey(scope.row.id)"
                        :disabled="!(scope.row.orders && isArray(scope.row.orders))"
                    >
                      关联订单({{
                        scope.row.orders && isArray(scope.row.orders) ? scope.row.orders.length : 0
                      }})
                    </el-link>
                    <el-link
                        @click="editBill(scope.row)"
                        type="primary"
                        style="margin-right: 10px"
                        v-permission="'can_invoice_list'"
                    >详情
                    </el-link>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <Pagination
                v-show="total > 0"
                :total="total"
                :page.sync="params.page"
                :limit.sync="params.per_page"
                @pagination="handleQuery"
            />
          </div>
        </div>
      </div>
    </div>
    <!--    发票详情-->
    <BillDetailDialog
        :visible.sync="dialogTableVisible"
        :id="id"
        @closed="closeDialog"
    />
  </div>
</template>

<script>
import {getBillList, markBillDone} from "@/api/bill";
import {getUserOption} from "@/api/user";
import ApplyOrderTable from "@/views/bill/components/ApplyOrderTable";
import CompanySelect from "@/views/adOrder/components/companySelect";
import BillDetailDialog from "@/views/bill/components/BillDetailDialog";
import BillExport from "@/views/bill/components/Export.vue";
import {isArray} from "@/utils/util";

const statusMap = {
  wait: {
    text: "待审核",
    color: "#FFA933",
  },
  pass: {
    text: "已通过",
    color: "#39BA85",
  },
  reject: {
    text: "已拒绝",
    color: "#FE5B83",
  },
};

const doneMap = {
  Y: {text: "是", color: "#39BA85",},
  N: {text: "否", color: "",}
}

const ModelSearch = {
  status: null,
  applicant_id: null,
  company_id: null,
  is_done_invoice: null,
  customer_name: null,
  invoice_title: null,
  tax_id: null,
  invoice_number: null,
  check_time: null,
}
export default {
  name: "bill",
  components: {BillExport, BillDetailDialog, CompanySelect, ApplyOrderTable},
  data() {
    return {
      statusMap,
      doneMap,
      tabActive: 0,
      hoverActive: false,
      dialogTableVisible: false,
      userOption: [],
      id: "", //current edit or operate id
      searchCondition: {...{}, ...ModelSearch},
      params: {
        page: 1,
        per_page: 15,
      },
      total: 0,
      billData: [],
      loading: false,
      expandKeys: [], //展开的行
    };
  },
  filters: {
    statusFilter(status) {
      const statusMap = {
        spe_invoice: "电子专票",
        common_invoice: "电子普票",
      };
      return statusMap[status];
    },
  },
  created() {
    this.searchCondition.status = "wait";
    this.handleQuery();
    this.getUserOption();
  },
  methods: {
    isArray,
    closeDialog() {
      this.handleQuery();
      this.dialogTableVisible = false;
    },
    statusFilterText(status) {
      return this.statusMap[status].text;
    },
    statusFilterColor(status) {
      return this.statusMap[status].color;
    },
    onSubmit() {
      this.params.page = 1;
      this.handleQuery();
    },
    handleQuery() {
      let searchCondition = this.searchCondition;
      this.getBillList({
        ...searchCondition,
        ...{page: this.params.page, per_page: this.params.per_page},
      });
    },
    onReset() {
      const status = this.searchCondition.status;
      this.searchCondition = {...{}, ...ModelSearch};
      this.searchCondition.status = status
      this.params.page = 1;
      this.handleQuery();
    },
    //查看详情
    editBill(row) {
      this.id = row.id;
      this.dialogTableVisible = true;
    },
    getBillList(data) {
      this.loading = true;
      getBillList(data).then((res) => {
        this.billData = res.model.data;
        this.total = res.model.total;
        this.loading = false;
      });
    },
    getUserOption() {
      getUserOption({}).then((res) => {
        this.userOption = res.model;
      });
    },
    tabClick(index) {
      this.tabActive = index;
      this.params.page = 1;
      if (index === 0) {
        this.searchCondition.status = "wait";
      } else if (index === 1) {
        this.searchCondition.status = "pass";
      } else {
        this.searchCondition.status = "reject";
      }
      this.handleQuery();
    },
    rowClassName({row, rowIndex}) {
      row.index = rowIndex + 1;
      if (rowIndex % 2 === 1) {
        return "table-row commonTable-row";
      } else {
        return "table-row success-row";
      }
    },
    handleExport: function (cmd) {
      this.$refs.export.handelStart(cmd)
    },
    appendExpandKey(id) {
      let index = this.expandKeys.indexOf(id);
      if (index > -1) this.expandKeys.splice(index, 1);
      else this.expandKeys.push(id);
    },
    handleHoverDone(index, is_done_invoice) {
      if (is_done_invoice === 'Y') {
        this.hoverActive = false
      } else {
        this.hoverActive = index
      }
    },
    /**
     * 标记开完
     * @param id
     * @returns {Promise<void>}
     */
    async handelMarkDone(id) {
      const {code, message} = await markBillDone({id})
      if (code !== 100000) {
        this.$message.error(message)
        return;
      }
      this.hoverActive = false
      this.$message.success('操作成功')

      this.handleQuery()
    }
  },
};
</script>

<style scoped>
.bill {
  /*margin-top: 70px;*/
}

.form {
  margin-top: 20px;
  margin-bottom: 8px;
}

.header {
  background: #fff;
  padding: 5px 10px 0 10px;
  border-bottom: 1px solid #f2f2f2;
}

.tableCon {
  background: #fff;
  padding: 8px 10px 0 10px;
}

span.dot {
  width: 4px;
  height: 4px;
  margin-right: 5px;
  background: red;
  display: inline-block;
  border-radius: 50%;
  vertical-align: middle;
}

.el-dropdown-menu__item:hover {
  color: #fe2d54;
  background-color: rgba(232, 198, 254, 0.16);
}

.funcbars-button {
  padding: 0 23px;
  color: rgb(254, 45, 84);
  font-size: 14px;
  border: 1px solid rgb(254, 45, 84);
  border-radius: 2px;
  cursor: pointer;
}
</style>
<style>
div.el-dialog__header {
  text-align: left;
}

.reject-dialog .el-dialog {
  width: 40%;
}

.tab-content {
  border: 1px solid #f2f2f2;
  /*height: 500px;*/
}

.tab-table {
  width: 150px;
  height: 40px;
  cursor: pointer;
  margin-right: 3px;
  background-color: rgba(242, 242, 242, 0.67);
  font-size: 15px;
  font-weight: 600;
  line-height: 40px;
  text-align: center;
  display: inline-block;
}

.tab-table-active {
  background-color: #ffffff;
}

.table-row {
  height: 30px;
}

.bill-border {
  margin-bottom: 24px;
  border: 1px solid #ebeef5;
  padding: 24px;
  position: relative;
}

.export-dropdown > span {
  /*border: 1px solid #FE2D54;*/
  color: #fe2d54;
}

.export-dropdown .el-input.is-focus .el-input__inner {
  border: 1px solid #fe2d54 !important;
}

.export-dropdown .el-input.is-focus .el-input__inner,
.el-select .el-input__inner:focus,
.export-select .el-input .el-input__inner:active {
  border: 1px solid #fe2d54 !important;
}

.invoice-source {
  border: #fe2d54 1px dashed;
  padding: 1px 8px;
  line-height: 12px;
  float: right;
  border-radius: 20px;
  transform: skewX(18deg);
  //width: 40px;
  font-size: 10px;

}
</style>
